export const backendDomain = 'https://access-server.herokuapp.com/'; // 'http://localhost:8080/';
